export const DND_TABLE_ITEM_TYPE = "CELL";
